import { Vector } from "../types";

export class Brick {
  private brickImage: HTMLImageElement = new Image();

  constructor(
    private brickWidth: number,
    private brickHeight: number,
    private position: Vector,
    private brickEnergy: number,
    image: string
  ) {
    this.brickWidth = brickWidth;
    this.brickHeight = brickHeight;
    this.position = position;
    this.brickEnergy = brickEnergy;
    this.brickImage.src = image;
  }

  //Gettters
  get width(): number {
    return this.brickWidth;
  }
  get height(): number {
    return this.brickHeight;
  }
  get pos(): Vector {
    return this.position;
  }
  get image(): HTMLImageElement {
    return this.brickImage;
  }
  get energy(): number {
    return this.brickEnergy;
  }

  //Setter
  set energy(nr: number) {
    this.brickEnergy = nr;
  }
}
